import * as t from '../actionTypes'
import axios from 'utils/axios'
import { guardFromErrors, extractErrorInfo } from 'utils/graphqlHelpers'
import { SimpleTextSetting } from '../types'

type SimpleTextSettingsList = {
  items: SimpleTextSetting[]
  total: number
}

type Payload = SimpleTextSettingsList & {
  page: number
}

export type FetchSimpleTextSettingsListAction = FSA<undefined, Payload, string>
type FetchSimpleTextSettingsList = () => MrxThunk<FetchSimpleTextSettingsListAction>
type QueryResponse = GraphQLResponse<'simpleTextSettingsListPage', SimpleTextSettingsList>

const FETCH_SIMPLE_TEXT_SETTINGS_LIST = `
  query fetchSimpleTextSettingsList ($page: Int, $size: Int, $workspaceId: Int!) {
    simpleTextSettingsListPage (page: $page, size: $size, workspaceId: $workspaceId) {
      items {
        id
        name
        apiToken
      }
      total
    }
  }
`

const fetchSimpleTextSettingsList: FetchSimpleTextSettingsList = () => async (dispatch, getState) => {
  dispatch({
    type: t.FETCH_SIMPLE_TEXT_SETTINGS_LIST,
    meta: { done: false }
  })

  try {
    const {
      workspaces: {
        activeWorkspace: { id: workspaceId }
      },
      simpleTextSettings: {
        pagination: { currentPage: page, size }
      }
    } = getState()
    const {
      data: { data, errors }
    }: QueryResponse = await axios.post('/graphql', {
      query: FETCH_SIMPLE_TEXT_SETTINGS_LIST,
      variables: { page, size, workspaceId }
    })

    guardFromErrors(errors)

    if (!data) {
      throw new Error('Response body is empty!')
    }

    const { simpleTextSettingsListPage } = data
    if (!simpleTextSettingsListPage) {
      throw new Error("Can't get SimpleText Settings list page!")
    }

    dispatch({
      type: t.FETCH_SIMPLE_TEXT_SETTINGS_LIST,
      payload: {
        page,
        total: simpleTextSettingsListPage.total,
        items: simpleTextSettingsListPage.items
      },
      meta: { done: true }
    })
  } catch (err) {
    dispatch({
      type: t.FETCH_SIMPLE_TEXT_SETTINGS_LIST,
      payload: extractErrorInfo(err),
      error: true
    })
  }
}

export { fetchSimpleTextSettingsList }
